import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { store } from 'store/store'
import css from './OutfitsButton.module.scss'

export const OutfitsButton = observer(() => {
  const { count } = store
  const dot = count > 0

  const onOutfits = useLatestCallback(() => {
    controller.openGenerations()
  })

  return (
    <Button className={css.button} gap={6} pad={[0, 4]} text compact action={onOutfits}>
      <Typo size={12} one upper medium>
        {i18n('MyOutfits')}
      </Typo>
      {dot && <Space className={css.dot} />}
    </Button>
  )
})
